import Immutable from 'immutable'

export const AuthenticationRecord = Immutable.Record({
  activeDisable: null,
  allowPasswordChange: false,
  username: '',
}, 'ServiceAuthentication')

export default function createServiceAuthentication({
  active_disable,
  allow_password_change,
  ...data
}) {
  return new AuthenticationRecord({
    activeDisable: active_disable,
    allowPasswordChange: allow_password_change,
    ...data,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Service/Authentication.js